import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { ChartContainer } from "../../view/ChartContainer";

export default function DeviceDetailsChartSkeleton({ title, buttons, isPieChart = false }) {
    return (
        <ChartContainer title={title} buttons={buttons} className="">
            
            <div className="oct_interactive-legend-wrapper-v2 pt-3">
                <div className="oct_interactive-legend-v2">
                    <Skeleton variant="rectangular" width={70} height={20} className="oct_skeleton-radius-4" />
                    <Skeleton variant="rectangular" width={70} height={20} className="oct_skeleton-radius-4" />
                    <Skeleton variant="rectangular" width={70} height={20} className="oct_skeleton-radius-4" />
                </div>
            </div>

            <div className="oct_recharts-wrapper-v2 oct_chart-no-interaction d-flex align-items-center justify-content-center">
                {isPieChart ? (
                    <Skeleton variant="circular" width={200} height={200} />
                ) : (
                    <Skeleton variant="rectangular" width="100%" height="100%" className="oct_skeleton-radius-4" />
                )}
            </div>
        </ChartContainer>
    );
}
